import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { IconButton } from "@base-ui/buttons";
import { Flex, Fieldset } from "@base-ui/containers";
import { InputContainer, Range } from "./rangeInput.styles";
import { Label } from "../rangeCommon.styles";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
var RangeInput = function RangeInput(props) {
  var id = props.id,
    legend = props.legend,
    label = props.label,
    steps = props.steps,
    value = props.value,
    _onChange = props.onChange,
    onStep = props.onStep,
    hideLegend = props.hideLegend,
    className = props.className;
  var handleStep = function handleStep(a) {
    var controlledValue = a < 0 ? 0 : a > steps ? steps : a;
    onStep(controlledValue);
  };
  return /*#__PURE__*/_jsx(Fieldset, _objectSpread(_objectSpread({
    className: className,
    hideLegend: hideLegend,
    legend: legend
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: /*#__PURE__*/_jsxs(Flex.Row, {
      children: [/*#__PURE__*/_jsx(IconButton, {
        className: "step-back",
        icon: "expandLeft",
        inverted: true,
        label: "Stega bak\xE5t",
        style: {
          borderRadius: "3px 0 0 3px"
        },
        disabled: value === 0,
        onClick: function onClick() {
          return handleStep(value - 1);
        }
      }), /*#__PURE__*/_jsxs(InputContainer, {
        children: [/*#__PURE__*/_jsx(Label, {
          htmlFor: "".concat(id),
          children: label
        }), /*#__PURE__*/_jsx(Range, {
          id: "".concat(id),
          "aria-label": label,
          type: "range",
          min: 0,
          max: steps,
          value: value,
          onChange: function onChange(e) {
            return _onChange(parseInt(e.target.value));
          }
        })]
      }), /*#__PURE__*/_jsx(IconButton, {
        className: "step-forward",
        icon: "expandRight",
        inverted: true,
        label: "Stega fram\xE5t",
        style: {
          borderRadius: "0 3px 3px 0"
        },
        disabled: value === steps,
        onClick: function onClick() {
          return handleStep(value + 1);
        }
      })]
    })
  }));
};
RangeInput.propTypes = {
  id: PropTypes.string.isRequired,
  legend: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onStep: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
  steps: PropTypes.number.isRequired,
  hideLegend: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string
};
export default RangeInput;